'use strict';

var Promise = global.Promise || require('promise-polyfill');

module.exports = Promise;



//////////////////
// WEBPACK FOOTER
// ../node_modules/braintree-web/lib/promise.js
// module id = 987
// module chunks = 0